import { filter } from 'lodash';
import moment from 'moment';

export const prepareFilters = filters => {
  const obj = filter(filters, x => x.selected).reduce((obj, item) => {
    switch (item.key) {
      case 'date_of_transaction': {
        switch (item.value.type) {
          case 'previous_month': {
            return ({ ...obj, since: 'now-1M/M', until: 'now/M' });
          }
          case 'this_month': {
            return ({ ...obj, since: 'now/M' });
          }
          case 'last_days': {
            return ({ ...obj, since: `now-${item.value.number}d/d` });
          }
          default: {
            return ({ ...obj, since: `${item.value.since}||/d`, until: `${item.value.until}||+1d/d` });
          }
        }
      }
      case 'date': {
        switch (item.value.type) {
          case 'previous_month': {
            return ({ ...obj, since: 'now-1M/M', until: 'now/M' });
          }
          case 'this_month': {
            return ({ ...obj, since: 'now/M' });
          }
          case 'last_days': {
            return ({ ...obj, since: `now-${item.value.number}d/d`, until: 'now+1d/d' });
          }
          default: {
            return ({ ...obj, since: `${item.value.since}||/d`, until: `${item.value.until}||+1d/d` });
          }
        }
      }
      case 'sort_more': {
        return ({ ...obj, sort: [item.value.key] });
      }
      case 'users': {
        return ({ ...obj, owner_uuids: item.value, user_uuids: item.value });
      }
      // case 'campaign_modifiers': {
      //   return ({ ...obj, modifier_ids: item.value.map(x => x.id) });
      // }
      case 'campaigns': {
        return ({ ...obj, campaign_ids: item.value.map(x => x.id) });
      }
      case 'lookbooks': {
        return ({ ...obj, lookbook_ids: item.value.map(x => x.id) });
      }
      case 'discount_codes': {
        return ({ ...obj, discount_code_ids: item.value.map(x => x.id) });
      }
      case 'connected_since': {
        if (!item.value) return obj;
        return ({ ...obj, connected_since: moment().subtract(7, 'days').startOf('day').format() });
      }
      case 'archived': {
        return ({ ...obj, exclude_archived: item.value === 'exclude' });
      }
      case 'gmv_per_period_quartiles': {
        return ({ ...obj, [item.key]: item.value.map(x => Number.parseInt(x)) });
      }
      case 'gmv_per_click_quartiles': {
        return ({ ...obj, [item.key]: item.value.map(x => Number.parseInt(x)) });
      }
      case 'links_per_period_quartiles': {
        return ({ ...obj, [item.key]: item.value.map(x => Number.parseInt(x)) });
      }
      case 'clicks_per_link_quartiles': {
        return ({ ...obj, [item.key]: item.value.map(x => Number.parseInt(x)) });
      }
      case 'active_links_range': {
        const activeLinksResult = {};
        if (item.value.min !== '') activeLinksResult.min_filtered_active_links = parseInt(item.value.min);
        if (item.value.max !== '') activeLinksResult.max_filtered_active_links = parseInt(item.value.max);
        return { ...obj, ...activeLinksResult };
      }
      case 'clicks_range': {
        const clicksResult = {};
        if (item.value.min !== '') clicksResult.min_filtered_clicks = parseInt(item.value.min);
        if (item.value.max !== '') clicksResult.max_filtered_clicks = parseInt(item.value.max);
        return { ...obj, ...clicksResult };
      }
      case 'gmv_range': {
        const gmvResult = {};
        if (item.value.min !== '') gmvResult.min_filtered_gmv = item.value.min;
        if (item.value.max !== '') gmvResult.max_filtered_gmv = item.value.max;
        return { ...obj, ...gmvResult };
      }
      // case 'statistics': {
      //   return ({ ...obj, stats: [item.value] });
      // }
      default: {
        return ({ ...obj, [item.key]: item.value });
      }
    }
  }, {});
  
  return obj;
};